import "../../css/views/projects.scss";

const catList = document.getElementById( "catList" ),
	projectCnt = document.getElementById( "projectsCnt" ),
	filterHash = window.location.hash.replace( "#", "" );

for ( let i = 0; i < catList.children.length; i++ ) {
	const catEl = catList.children[ i ]
	const filter = catEl.dataset.filter;
	const filterName = catEl.dataset.filterName;

	if ( filterHash )
		catEl.classList.remove( "isActive" )

	/* initial load filtering  */
	if ( filterHash == filterName ) {
		catEl.classList.add( "isActive" )
		filterProjects( filter )
	}

	catEl.addEventListener( "click", e => {
		e.preventDefault()
		e.stopImmediatePropagation()

		window.location.hash = filterName;

		for ( let i = 0; i < catList.children.length; i++ ) {
			const el = catList.children[ i ]

			el.dataset.filter == filter
				? el.classList.add( "isActive" )
				: el.classList.remove( "isActive" )
		}

		filterProjects( filter )
	} )

}

function filterProjects( filterID ) {
	for ( let i = 0; i < projectCnt.children.length; i++ ) {
		const project = projectCnt.children[ i ]
		if ( filterID == "0" ) {
			project.classList.remove( "hide" )
		} else {

			const projectCats = project.dataset.id.split( "," )
			const catMatches = projectCats.some( id => id == filterID )

			!catMatches
				? project.classList.add( "hide" )
				: project.classList.remove( "hide" )
		}

	}
}